/**
 * Fishing Progress
 * Shows countdown timer text when fishing
 */

import { FishingState } from '@/types';
import { useFishingState } from '@/state';
import { formatTime } from '@/data';

export function FishingProgress() {
  const fishingState = useFishingState();

  if (fishingState.status !== FishingState.WAITING) {
    return null;
  }

  const timeRemaining = Math.max(0, fishingState.timeRemaining);

  return (
    <div className="text-center text-gray-300">
      {formatTime(timeRemaining)}
    </div>
  );
}
